import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mis-suscripciones',
  templateUrl: './mis-suscripciones.component.html',
})
export class MisSuscripcionesComponent implements OnInit {
  suscripcion: any = null;
  cargando = true;
  error = '';
  cancelando = false;

  constructor(private http: HttpClient) {}

  ngOnInit(): void { this.cargar(); }

  cargar(): void {
    this.cargando = true;
    this.error = '';
    this.http.get(`${environment.baseApi}/privado/suscripcion`).subscribe({
      next: (res: any) => {
        this.suscripcion = res?.data;
        this.cargando = false;
      },
      error: (e) => {
        this.error = e?.error?.message || 'Error al cargar la información de suscripción.';
        this.cargando = false;
      }
    });
  }

  cancelar(): void {
    if (this.cancelando) return;
    if (!confirm('¿Cancelar suscripción?\n\nMantendrás acceso Premium hasta el final de tu período de facturación. No se harán más cobros.')) return;

    this.cancelando = true;
    this.error = '';
    this.http.post(`${environment.baseApi}/privado/suscripcion/cancelar`, {}).subscribe({
      next: () => {
        this.cancelando = false;
        this.cargar();
      },
      error: (e) => {
        this.cancelando = false;
        this.error = e?.error?.message || 'Error al cancelar la suscripción. Intenta de nuevo.';
      }
    });
  }
}
